import { createClient } from '@supabase/supabase-js';

const supabaseUrl = 'https://somacujkgpnctuwlauyg.supabase.co';
const supabaseAnonKey =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InNvbWFjdWprZ3BuY3R1d2xhdXlnIiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzY3NTQzNDUsImV4cCI6MTk5MjMzMDM0NX0.c-ADecHqB1rYgUU11YvLHRRyxkiLObgRkf-dvQdVOGw';

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
